<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Passing Grade" >
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="tableData"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                :rowClassName="(r) => r.is_heading ? 'row-heading' : null"
                bordered
                >

                <a-table-column key="title" title="Aspek Penilaian" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <template v-if="record.is_heading">
                            <strong>{{ record.name }}</strong>
                        </template>
                        <template v-else>
                            {{ record.name }}
                        </template>
                    </template>
                </a-table-column>

                <a-table-column key="weight" title="Bobot" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.weight }} %
                    </template>
                </a-table-column>
            </a-table>
        </a-card>
    </div>
</template>

<script>
const aspects = {
    id: null,
    name: null,
    is_heading: false,
    weight: null,
    type: null
}

export default {
    data() {
        return {
            loading: false,
            items: {
                aspects: []
            },
        }
    },
    created() {
        this.getItems()
    },
    computed: {
        tableData() {
            let collection = [], id = 0

            this.items.aspects.forEach(function (item, index) {
                collection.push(Object.assign(Object.create(aspects), {
                    id: id,
                    name: item.name,
                    is_heading: true,
                    weight: item.aspect_weight,
                    type: item.type
                }))
                
                id++

                item.children.forEach(function (item, index) {
                    collection.push(Object.assign(Object.create(aspects), {
                        id: id,
                        name: item.name,
                        is_heading: false,
                        weight: item.perspective_weight,
                        type: item.type
                    }))
                    id++
                })
            })

            return collection
        },
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.performance.settings.objectives-passing-grade'))
                .then(response => {
                    this.items = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
    }
}
</script>